export default __webpack_public_path__ + "static/media/1972.57860f9d.png";